import { countries } from '../../utils/constants';

export const COMPANY_CARD_CATEGORIES = {
  company: 'company',
  soldTo: 'soldTo',
  billTo: 'billTo'
};

export const SHIP_TO_CARD_CATEGORIES = {
  shipTo: 'shipTo',
  deliveryDetails: 'deliveryDetails',
  invoiceDelivery: 'invoiceDelivery',
  deliveryInstructions: 'deliveryInstructions',
  coa: 'coa',
  packingList: 'packingList',
  orderConfirmation: 'orderConfirmation',
  address: 'address'
};

export const FINANCIAL_CARD_CATEGORIES = {
  accountPayable: 'accountPayable',
  bankReference: 'bankReference',
  bankerContact: 'bankerContact',
  payer: 'payer',
  financialAttachmentCard: 'financialAttachmentCard',
  // signature: 'signature',
  attachmentCard: 'attachmentCard',
  privacyPolicy: 'privacyPolicy',
  additionalAttachmentCard: 'additionalAttachmentCard'
};

export const CARD_CATEGORIES = {
  ...COMPANY_CARD_CATEGORIES,
  ...FINANCIAL_CARD_CATEGORIES,
  ...SHIP_TO_CARD_CATEGORIES,
  multiShipTo: 'multiShipTo',
  contactCard: 'contactCard'
};

export const defaultAddressFields = [
  {
    field: 'country',
    label: 'Select a Country',
    options: countries
  },
  { field: 'street', label: 'Street' },
  { field: 'city', label: 'City' },
  { field: 'state', label: 'State' },
  { field: 'zipCode', label: 'Zip Code' }
];
